import * as navigation from 'Navigation';

export default class PlateTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Plate',
      closeable: false,
      preferenceKey: 'plate',
    };
  }
}
